import {Component, Input} from '@angular/core'

@Component({
  selector: 'bgo-profile-badge',
  templateUrl: './profile-badge.component.html',
  styles: [':host {display: block;}'],
  standalone: false,
})
export class ProfileBadgeComponent {
  @Input() label!: string
  @Input() iconPath!: string
}
